export function getLighterHexColor(color, percent) {
  // If no color provided, return a default
  if (!color) return "rgba(255, 0, 0, 0.1)"; // Default fallback

  // If it's already an RGB/RGBA value, just adjust opacity
  if (color.startsWith("rgb")) {
    if (color.startsWith("rgba")) {
      return color.replace(/[\d\.]+\)$/, `${percent})`);
    }
    return color.replace(")", `, ${percent})`).replace("rgb", "rgba");
  }

  // Handle hex colors (both 3 and 6 digit)
  if (color.startsWith("#")) {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    const hex = color.slice(1);
    const fullHex =
      hex.length === 3
        ? hex
            .split("")
            .map((x) => x + x)
            .join("")
        : hex;

    const r = parseInt(fullHex.substring(0, 2), 16);
    const g = parseInt(fullHex.substring(2, 4), 16);
    const b = parseInt(fullHex.substring(4, 6), 16);

    return `rgba(${r}, ${g}, ${b}, ${percent})`;
  }

  // Fallback for unexpected formats

  return `rgba(255, 0, 0, ${percent})`;
}

//darken
export function getDarkerHexColor(color, percent) {
  // If no color provided, return a default
  if (!color) return "rgba(0, 0, 0, 0.1)"; // Default fallback

  // If it's already an RGB/RGBA value, reduce brightness
  if (color.startsWith("rgb")) {
    const rgba = color
      .replace(/[^\d,\.]/g, "")
      .split(",")
      .map(Number);

    const [r, g, b, a = 1] = rgba;
    const factor = 1 - percent;

    return `rgba(${Math.round(r * factor)}, ${Math.round(
      g * factor
    )}, ${Math.round(b * factor)}, ${a})`;
  }

  // Handle hex colors (both 3 and 6 digit)
  if (color.startsWith("#")) {
    const hex = color.slice(1);
    const fullHex =
      hex.length === 3
        ? hex
            .split("")
            .map((x) => x + x)
            .join("")
        : hex;

    const r = parseInt(fullHex.substring(0, 2), 16);
    const g = parseInt(fullHex.substring(2, 4), 16);
    const b = parseInt(fullHex.substring(4, 6), 16);

    const factor = 1 - percent;

    return `rgba(${Math.round(r * factor)}, ${Math.round(
      g * factor
    )}, ${Math.round(b * factor)}, 1)`;
  }

  // Fallback for unexpected formats
  return `rgba(0, 0, 0, 0.1)`;
}
